<div class="content">
  <div class="text">
    <h2>Why Boutiques Trust Us</h2>
    <ul>
      <li>
        <mat-icon fontIcon="more_time"></mat-icon
        ><span>7+ Years of Experience</span>
      </li>
      <li>
        <mat-icon fontIcon="high_quality"></mat-icon
        ><span>High-Quality Materials</span>
      </li>
      <li>
        <mat-icon fontIcon="eco"></mat-icon><span>Eco-Conscious Design</span>
      </li>
      <li>
        <mat-icon fontIcon="checkroom"></mat-icon
        ><span>Boutique-Ready Styles</span>
      </li>
      <li>
        <mat-icon fontIcon="recycling"></mat-icon
        ><span>Free Returns for Defective Items</span>
      </li>
    </ul>
  </div>
  <app-card-stack></app-card-stack>
</div>

<div class="info">
  <div>
    <mat-icon fontIcon="location_on"></mat-icon>
    <span>{{address1}} {{address2}}</span>
  </div>
  <div>
    <a app-instgram-logo [size]="24"></a>
  </div>
  <div>
    <mat-icon fontIcon="email"></mat-icon>
    <a href="mailto:support@euphlane.com" target="_blank"
      >support@euphlane.com</a
    >
  </div>
</div>
